import { render, staticRenderFns } from "./textDragDrop.vue?vue&type=template&id=b849fcaa&scoped=true"
import script from "./textDragDrop.vue?vue&type=script&lang=js"
export * from "./textDragDrop.vue?vue&type=script&lang=js"
import style0 from "./textDragDrop.vue?vue&type=style&index=0&id=b849fcaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b849fcaa",
  null
  
)

export default component.exports